import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFacebookF, 
  faXTwitter, 
  faYoutube, 
  faLinkedinIn, 
  faInstagram, 
  faSnapchatGhost,
  faTiktok 
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  // const locations = [
  //   'Arlington', 'Boston', 'Burlington', 'Charlotte', 'London', 'Miami',
  //   'Nahant', 'Oakland', 'Portland', 'Seattle', 'Silicon Valley', 'Toronto', 'Vancouver'
  // ];

  const socialLinks = [
    { name: 'Facebook', icon: faFacebookF, url: 'https://www.facebook.com/northeastern/' },
    { name: 'Twitter', icon: faXTwitter, url: 'https://x.com/Northeastern' },
    { name: 'YouTube', icon: faYoutube, url: 'https://www.youtube.com/user/Northeastern' },
    { name: 'LinkedIn', icon: faLinkedinIn, url: 'https://www.linkedin.com/school/northeastern-university/posts/?feedView=all' },
    { name: 'Instagram', icon: faInstagram, url: 'https://www.instagram.com/northeastern/' },
    { name: 'Snapchat', icon: faSnapchatGhost, url: 'https://www.snapchat.com/@northeasternu' },
    { name: 'TikTok', icon: faTiktok, url: 'https://www.tiktok.com/@northeasternu' }
  ];

  return (
    <footer className="northeastern-footer">
      <div className="footer-container">
        {/* University Title */}
        <div className="footer-title">
          <a href="https://siliconvalley.northeastern.edu/" target="_blank" rel="noopener noreferrer">
            <h2>Northeastern University</h2>
          </a>
        </div>

        {/* Locations
        <div className="footer-locations">
          {locations.map((location, index) => (
            <a key={index} href="#" className="location-link">
              {location}
            </a>
          ))}
        </div> */}
        
        <div class='footer-legal-social'>
          {/* Legal Links */}
          <div className="footer-legal">
            <a href="https://www.northeastern.edu/emergency-information/" target="_blank" className="legal-link">Emergency Information</a>
            <span className="separator">|</span>
            <a href="https://www.northeastern.edu/privacy-information/" target="_blank" className="legal-link">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="https://digital-accessibility.northeastern.edu/" target="_blank" className="legal-link">Accessibility</a>
            <span className="separator">|</span>
            <p className='footer-copyright'>© 2025 Northeastern University</p>
          </div>

          {/* Social Media Icons */}
          <div className="footer-social">
            {socialLinks.map((social, index) => (
              <a key={index} href={social.url} target='_blank' className="social-link" aria-label={social.name}>
                <FontAwesomeIcon icon={social.icon} className="social-icon" />
              </a>
            ))}
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;

// import React from "react";
// import "./Footer.css";
// import { developers } from "../../../src/lib/constants";

// const Developer = ({ name, imageSrc, program, linkedin }) => (
//   <div className="developer-info">
//     <img src={imageSrc} alt={name} className="developer-image" />
//     <div className="developer-details">
//       <div className="developer-name">
//         <a href="https://siliconvalley.northeastern.edu" target="_blank" rel="noopener noreferrer">
//             <p>Northeastern University</p>
//         </a>
//       </div>
//       <div className="developer-program">
//         <a href="https://www.northeastern.edu/emergency-information/" target="_blank" rel="noopener noreferrer">
//             <p> Emergency Information </p>
//         </a>
//         <p> | </p>
//         <a href="https://www.northeastern.edu/privacy-information/" target="_blank" rel="noopener noreferrer">
//             <p> Privacy Policy </p>
//         </a>
//         <p> | </p>
//         <a href="https://digital-accessibility.northeastern.edu/" target="_blank" rel="noopener noreferrer">
//             <p> Accessibility </p>
//         </a>
//       </div>
//     </div>
//   </div>
// );

// const Footer = () => {
//   return (
//     <div className="footer-container">
//       <div className="developers-title">
//         <p>Northeastern University</p>
//         <div className="developers-info-container">
//           {developers.map((developer) => (
//             <Developer
//               key={developer.name}
//               name={developer.name}
//               imageSrc={developer.imageSrc}
//               program={developer.program}
//               linkedin={developer.linkedin}
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;